import { formatAmount } from '@krp/ui-kit'
import { formatKopecks } from '@krp/sale-ui'

export { formatKopecks }

/** Цена строкой «123.45» → «123,45 ₽». Пустая цена — словами: `null` ≠ 0. */
export const formatPrice = (price: string | null): string => formatAmount({ decimal: price }, 'цена не задана')
